import React, { useState } from "react";

const MembershipServiceSuggestion = ({ 
  data, 
  handleServiceSuggestedClick 
}) => {
  const [hoveredSuggestion, setHoveredSuggestion] = useState(null);

  const handleServiceSelect = (service, e) => {
    e.preventDefault();
    e.stopPropagation();
    handleServiceSuggestedClick(service);
  };

  // Group services by category if available
  const groupedServices = data.reduce((acc, service) => {
    const category = service.category || 'Services';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(service);
    return acc;
  }, {});

  const containerStyle = {
    position: "absolute",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    zIndex: 1300,
    maxHeight: "300px",
    overflowY: "auto",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
    width: "100%",
    borderRadius: "4px",
    marginTop: "2px"
  };

  const categoryStyle = {
    fontWeight: "bold",
    padding: "10px 12px",
    backgroundColor: "#f8f9fa",
    borderBottom: "1px solid #dee2e6",
    fontSize: "14px",
    color: "#495057",
    position: "sticky",
    top: 0,
    zIndex: 1
  };

  const itemStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    cursor: "pointer",
    borderBottom: "1px solid #e9ecef",
    fontSize: "14px",
    transition: "background-color 0.2s ease"
  };

  const priceStyle = {
    fontWeight: "bold",
    color: "#28a745",
    fontSize: "13px"
  };

  return (
    <div style={containerStyle}>
      {Object.entries(groupedServices).map(([category, services]) => (
        <div key={category}>
          <div style={categoryStyle}>{category}</div>
          {services.map((service) => (
            <div
              key={service._id}
              onClick={(e) => handleServiceSelect(service, e)}
              style={{
                ...itemStyle,
                backgroundColor: hoveredSuggestion === service._id ? "#6174DD" : "white",
                color: hoveredSuggestion === service._id ? "white" : "#212529",
              }}
              onMouseEnter={() => setHoveredSuggestion(service._id)}
              onMouseLeave={() => setHoveredSuggestion(null)}
            >
              <span>{service.serviceName}</span>
              <span style={priceStyle}>₹{service.price}</span>
            </div>
          ))}
        </div>
      ))}
      
      {data.length === 0 && (
        <div style={{ padding: "12px", color: "#6c757d", textAlign: "center", fontSize: "14px" }}>
          No services found
        </div>
      )}
    </div>
  );
};

export default MembershipServiceSuggestion;